import { render, staticRenderFns } from "./SysDepartMoveList.vue?vue&type=template&id=50f4a26a&scoped=true&"
import script from "./SysDepartMoveList.vue?vue&type=script&lang=js&"
export * from "./SysDepartMoveList.vue?vue&type=script&lang=js&"
import style0 from "./SysDepartMoveList.vue?vue&type=style&index=0&id=50f4a26a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f4a26a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f4a26a')) {
      api.createRecord('50f4a26a', component.options)
    } else {
      api.reload('50f4a26a', component.options)
    }
    module.hot.accept("./SysDepartMoveList.vue?vue&type=template&id=50f4a26a&scoped=true&", function () {
      api.rerender('50f4a26a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/SysDepartMoveList.vue"
export default component.exports